import numeral from 'numeral';

export class NumberHelper {
  public static percent(total: number, over: number): string {
    const result = over === 0  || total === 0 ? 0 : over / total;

    return numeral(result).format('0.0%');
  }

  public static percentNumber(val: number, over: number = 100): number {
    return parseFloat((val * over).toFixed(2));
  }
}
